export default {
    toPage(src) {
        if (src) window.location.href = src
    }
}